import { z } from 'zod';
import { TimeSchema } from './time';

export const VenueHoursStatus = ['open', 'closed'] as const;

export const VenueHoursSchema = z.object({
  startTime: TimeSchema,
  endTime: TimeSchema,
  status: z.enum(VenueHoursStatus),
});
